'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _PagingModel2 = require('./PagingModel');

var _PagingModel3 = _interopRequireDefault(_PagingModel2);

var _utilsLib = require('utils-lib');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var moment = require('moment');
moment().format();

var DocumentsModel = function (_PagingModel) {
    _inherits(DocumentsModel, _PagingModel);

    /**
     * Liste von Dokumenten
     * @type {array} of Documents
     */


    /**
     * Maximale Anzahl von Dokumenten am Kunden
     * @type {integer}
     */

    /**
     * Maximale Dateigröße
     * @type {integer}
     */

    /**
     * Anzahl von Dokumenten am Kunden
     * @type {integer}
     */


    /**
     * War das Löschen des Dokuments erfolgreich?
     * @type {boolean}
     */
    function DocumentsModel(observers, id, request) {
        _classCallCheck(this, DocumentsModel);

        var _this = _possibleConstructorReturn(this, (DocumentsModel.__proto__ || Object.getPrototypeOf(DocumentsModel)).call(this, observers, id, request));

        _this.Documents = [];

        _this.MaxNumber = 0;
        _this.MaxSize = 0;
        _this.NumberOfDocuments = 0;

        _this.DeleteSuccess = false;

        _this.UploadSuccess = false;

        _this.DocumentId = '';
        return _this;
    }

    /**
     * War das Hochland des Dokuments erfolgreich?
     * @type {boolean}
     */


    _createClass(DocumentsModel, [{
        key: 'GetDocumentsByCustomerId',
        value: function GetDocumentsByCustomerId(customerId, senddata, start, limit, orderColumn, orderDirection) {

            var reqString = "/Customers/" + customerId + "/Documents" + this.setSendData(senddata, start, limit, orderColumn, orderDirection);
            var me = this;

            this.request.setRequest(reqString);
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    me.setResult(result);
                    if (result.Data) {

                        var data = result.Data;
                        if (data.Data) {
                            var documents = [];
                            if (data.Data) {
                                data.Data.forEach(function (value) {
                                    var document = {};
                                    document.Id = value.Id;
                                    document.FileName = value.FileName;
                                    document.FileSize = _utilsLib.FileSizeConverter.Convert(value.FileSize);
                                    documents.push(document);
                                });
                            }
                            me.Documents = documents;
                        }
                    }
                }
                var id = me.Id ? me.Id : "Documents";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'GetFileParamsByCustomerId',
        value: function GetFileParamsByCustomerId(customerId) {
            var me = this;
            this.request.setRequest("/FileParams?customerId=" + customerId);
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        var data = result.Data;
                        me.MaxNumber = data.MaxNumber;
                        me.MaxSize = data.MaxSize;
                        me.NumberOfDocuments = data.NumberOfDocuments;
                    }
                }
                var id = me.Id ? me.Id : "FileParams";
                me.Notify(id);
            });
            this.request.doRequest();
        }
    }, {
        key: 'DeleteDocumentByDocumentId',
        value: function DeleteDocumentByDocumentId(documentId) {
            var me = this;
            this.request.setRequest("/Documents?documentId=" + documentId);
            this.request.setType("DELETE");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        me.DeleteSuccess = result.Data;
                    }
                }
                var id = me.Id ? me.Id : "DeleteDocument";
                me.Notify(id);
            });
            this.request.doRequest();
        }
    }, {
        key: 'UploadDocument',
        value: function UploadDocument(customerId, files) {
            var me = this;
            this.request.setRequest("/Documents");
            this.request.setDataType(null);
            this.request.setContentType(false);
            this.request.setType("POST");

            var formData = new FormData();
            for (var i = 0; i < files.length; i++) {
                if (files[i]) {
                    if (files[i].name) {
                        formData.append("file", files[i], files[i].name);
                    }
                }
            }
            formData.append("customerId", customerId);
            this.request.setData(formData);

            this.request.setProcessData(false);

            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        me.UploadSuccess = result.Data;
                    }
                }
                var id = me.Id ? me.Id : "UploadDocument";
                me.Notify(id);
            });
            this.request.doRequest();
        }
    }, {
        key: 'GetGlobalDocumentsByCustomerId',
        value: function GetGlobalDocumentsByCustomerId(customerId, senddata, start, limit, orderColumn, orderDirection) {

            var reqString = "/Customers/" + customerId + "/GlobalDocuments" + this.setSendData(senddata, start, limit, orderColumn, orderDirection);
            var me = this;

            this.request.setRequest(reqString);
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    me.setResult(result);
                    if (result.Data) {

                        var data = result.Data;
                        if (data.Data) {
                            var documents = [];
                            if (data.Data) {
                                data.Data.forEach(function (value) {
                                    var document = {};
                                    document.Id = value.Id;
                                    document.FileName = value.FileName;
                                    document.FileSize = _utilsLib.FileSizeConverter.Convert(value.FileSize);
                                    documents.push(document);
                                });
                            }
                            me.Documents = documents;
                        }
                    }
                }
                var id = me.Id ? me.Id : "GlobalDocuments";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'GetDocumentById',
        value: function GetDocumentById(id) {
            if (id !== null && id !== undefined) {
                var me = this;

                this.DocumentId = id;
                this.request.setRequest("/Documents/" + id);
                this.request.setType("GET");
                this.request.setCallback(function (result) {
                    if (result) {
                        if (result.Data) {
                            me.Documents = result.Data;
                        }
                    }
                    var id = me.Id ? me.Id : "DocumentById";
                    me.Notify(id);
                });

                this.request.doRequest();
            }
        }
    }, {
        key: 'base64ToArrayBuffer',
        value: function base64ToArrayBuffer(base64, me) {
            //https://stackoverflow.com/questions/35038884/download-file-from-bytes-in-javascript 10.07.18

            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }

            var bytes2 = [];
            for (var _i = 0; _i < bytes.length; _i++) {
                // jetzt gehts auch im IE
                var byteString = bytes[_i].toString(16);

                //add leading zero here when bytestring is digit
                if (byteString.length === 1) {
                    byteString = "0" + byteString;
                }

                bytes2.push(byteString);
            }

            /*bytes.forEach((byte) => {// ging nicht im IE
                bytes2.push(byte.toString(16))
            })*/
            var hex = bytes2.join('').toUpperCase();

            var type = this.getMimetype(hex.substr(0, 8));

            return [bytes, type];
        }

        //download not working in firefox-->Lösung:https://stackoverflow.com/questions/27115748/download-attribute-not-working-in-firefox 23.07.2018

    }, {
        key: 'saveByteArray',
        value: function saveByteArray(byte, filename) {
            var blob = new Blob([byte]);
            if (window.navigator.msSaveOrOpenBlob) // https://github.com/mholt/PapaParse/issues/175 23.07.2018 IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
                {
                    window.navigator.msSaveBlob(blob, filename);
                } else {
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }

        //https://medium.com/the-everyday-developer/detect-file-mime-type-using-magic-numbers-and-javascript-16bc513d4e1e 16.10.2018

    }, {
        key: 'getMimetype',
        value: function getMimetype(signature) {

            switch (signature) {
                case '89504E47':
                    return 'png';
                case '47494638':
                    return 'gif';
                case '425047FB':
                    return 'bpg';
                case 'FFD8FFDB':
                case 'FFD8FFE0':
                case 'FFD8FFE1':
                    return 'jpeg';
                case '25504446':
                    return 'pdf';
                case '504B0304':
                case '504B0506':
                    return 'docx';
                case 'D0CF11E0':
                    return 'doc';
                case '49492A00':
                case '4D4D002A':
                    return 'tif';

                default:
                    var blubb = signature.substr(0, 4);

                    switch (blubb) {
                        case '424D':
                            return 'bmp';
                        default:
                            return '';
                    }
            }
        }
    }]);

    return DocumentsModel;
}(_PagingModel3.default);

exports.default = DocumentsModel;